export default function isBrowserEnv() {

    return typeof document != "undefined";
}